import React from "react";
import { Box, Typography, alpha, useTheme } from "@mui/material";
import CloudDownloadIcon from "@mui/icons-material/CloudDownload";

const LoadingComp = () => {
  const theme = useTheme();
  const color = theme.palette.primary.main;

  return (
    <Box
      sx={{
        position: "fixed",
        inset: 0,
        zIndex: 9999,
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        bgcolor: alpha(theme.palette.background.default, 0.85),
        backdropFilter: "blur(8px)",
      }}
    >
      {/* Pulsing rings */}
      {[1, 2, 3].map((i) => (
        <Box
          key={i}
          sx={{
            position: "absolute",
            width: 60 + i * 40,
            height: 60 + i * 40,
            borderRadius: "50%",
            border: `1px solid ${alpha(color, 0.3 / i)}`,
            animation: `pulse-ring ${1 + i * 0.3}s ease-out infinite`,
            "@keyframes pulse-ring": {
              "0%": { transform: "scale(0.8)", opacity: 1 },
              "100%": { transform: "scale(1.4)", opacity: 0 },
            },
            animationDelay: `${i * 0.2}s`,
          }}
        />
      ))}

      {/* Center icon */}
      <Box
        sx={{
          width: 64,
          height: 64,
          borderRadius: "50%",
          zIndex: 1,
          background: `linear-gradient(135deg, ${color} 0%, ${alpha(color, 0.7)} 100%)`,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          boxShadow: `0 0 32px ${alpha(color, 0.5)}`,
          animation: "float 2s ease-in-out infinite",
          "@keyframes float": {
            "0%, 100%": { transform: "translateY(0)" },
            "50%": { transform: "translateY(-8px)" },
          },
        }}
      >
        <CloudDownloadIcon sx={{ fontSize: 30, color: "#fff" }} />
      </Box>

      <Typography
        variant="body2"
        fontWeight={600}
        color="text.secondary"
        sx={{
          mt: 3,
          zIndex: 1,
          animation: "fade 1.5s ease-in-out infinite",
          "@keyframes fade": {
            "0%, 100%": { opacity: 0.5 },
            "50%": { opacity: 1 },
          },
        }}
      >
        Loading...
      </Typography>
    </Box>
  );
};

export default LoadingComp;
